<template>
	<v-card class="fill-height">
		<v-card-title>
			<h3 class="headline font-weight-bold">{{getObjectValue('name', attribute)}}</h3>
			<v-spacer></v-spacer>
			<v-tooltip top v-if="onEditRoute">
				<v-btn icon flat slot="activator" to="edit" append>
					<div class="v-icon">
						<fa-icon :icon="['far', 'pencil-alt']" size="xs" />
					</div>
				</v-btn>
				<span>Edit</span>
			</v-tooltip>
			<v-tooltip top v-else>
				<v-btn icon flat slot="activator" @click="$router.back();" append>
					<div class="v-icon">
						<fa-icon :icon="['far', 'times']" size="xs" />
					</div>
				</v-btn>
				<span>Cancel</span>
			</v-tooltip>
		</v-card-title>

		<!-- <code>{{attribute}}</code> -->

		<v-fade-transition mode="out-in" appear>
			<router-view :key="$route.fullPath" :attribute="attribute" v-if="attribute"></router-view>
		</v-fade-transition>
	</v-card>
</template>

<script>
import { mapGetters } from "vuex";

export default {
	data() {
		return {
			// attribute: null
		};
	},

	props: {
		id: {
			default: null
		}
	},

	computed: {
		...mapGetters("admin", {
			SELECTED_ATTRIBUTE: "selectedAttribute",
			ATTRIBUTES: "attributes"
		}),

		onEditRoute() {
			return this.$route.fullPath.indexOf("edit") === -1;
		},

		attribute() {
			if (!this.ATTRIBUTES) {
				return null;
			}

			return this.SELECTED_ATTRIBUTE(this.id);
		}
	}
};
</script>
